module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/icon-enthusiasm-20c3735f57e8864f4395a0da18ddea9a.svg";